import { useAuthStore } from "@/stores/authStore";
// 👉 Redirects
export const redirects = [
  // ℹ️ We are redirecting to different pages based on role.
  // NOTE: Role is just for UI purposes. ACL is based on abilities.
  {
    path: "/",
    name: "index",
    redirect: (to) => {
      const user = useCookie("user").value;
      const accessToken = useCookie("accessToken").value;
      const isLoggedIn = !!(user && accessToken);

      if (!isLoggedIn) {
        return { name: "login", query: to.query };
      }
      if (!user.termsAccepted) {
        return { name: "reglement" };
      }
      
      return { name: "index" };
      // return {name: 'campaign-id', params: {id: CURRENT_YEAR}}
    },
  },
  {
    path: "/table-program",
    name: "table-program",
    redirect: (to) => {
      const authStore = useAuthStore();
      const isLoggedIn = !!(
        authStore.user &&
        authStore.accessToken &&
        authStore.userAbilityRules
      );
      // console.log(isLoggedIn, "isLoggedIn first route");
      if (!isLoggedIn) {
        return { name: "login", query: to.query };
      }
      // console.log(authStore.userAbilityRules);

      return { name: "table-program" };
      // return {name: 'campaign-id', params: {id: CURRENT_YEAR}}
    },
  },
];
export const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("@/pages/index.vue"),
  },
];
